module.exports = __webpack_public_path__ + "img/green-grain.c8471f73.png";